export enum SellersStatusType {
  SST_UNSET = 'SST_UNSET', // Do not use, needed because of proto3 limitations
  SST_ACTIVATED = 'SST_ACTIVATED',
  SST_DEACTIVATED = 'SST_DEACTIVATED',
}
